import React from 'react';
import classnames from 'classnames';
import BlockHeader from 'swag-client-common/components/ui/block-header';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import bravoImage from 'assets/svg/bravo.svg';
import gamesImage from 'assets/img/home/addicting-games.png';
import harrysImage from 'assets/svg/harrys.svg';
import classes from './testimonials.scss';
import { SeeMoreButton } from './testimonials-see-more-btn';
export const Testimonials = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.testimonials, className)
  }, /*#__PURE__*/React.createElement(AnimationWrapper, {
    offset: 200,
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(BlockHeader, {
    textClassName: classes.sectionHeader
  }, "AW, YOU GUYS\u2026"), /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.block
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.brandLogo,
    src: bravoImage,
    alt: "Word 'Bravo' in bold inside a speech bubble"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.head
  }, "Talia Solomon"), /*#__PURE__*/React.createElement("p", {
    className: classes.p
  }, "Swag.com introduced us to a new caliber of product. We look forward to working with Swag.com in the future!")), /*#__PURE__*/React.createElement("div", {
    className: classes.block
  }, /*#__PURE__*/React.createElement("img", {
    className: classnames(classes.brandLogo, classes.wideLogo),
    src: gamesImage,
    alt: "Logo of Addicting Games, written in uppercase letters"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.head
  }, "Bill Karamouzis"), /*#__PURE__*/React.createElement("p", {
    className: classes.p
  }, "We love Swag.com especially because they only offer swag people will actually want to keep. We use swag to promote our ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: "https://www.addictinggames.com",
    className: classes.link
  }, "games"), ' ', "and educational", ' ', /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: "https://www.mathgames.com",
    className: classes.link
  }, "math"), "products.")), /*#__PURE__*/React.createElement("div", {
    className: classes.block
  }, /*#__PURE__*/React.createElement("img", {
    className: classnames(classes.brandLogo, classes.highLogo),
    src: harrysImage,
    alt: "Logo of Harry's, written in uppercase letters"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.head
  }, "Ryan Krebs"), /*#__PURE__*/React.createElement("p", {
    className: classes.p
  }, "Swag.com is making the entire swag designing & buying process seamless. It took barely a minute to buy sweatshirts for our entire team, and they are the most popular swag we've ever had in the office."))), /*#__PURE__*/React.createElement(SeeMoreButton, {
    className: classes.button
  })));
};